import { render } from "./tblLivroMatricula.vue?vue&type=template&id=25b1b0e4&scoped=true"
import script from "./tblLivroMatricula.vue?vue&type=script&lang=js"
export * from "./tblLivroMatricula.vue?vue&type=script&lang=js"

import "./tblLivroMatricula.vue?vue&type=style&index=0&id=25b1b0e4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b1b0e4"]])

export default __exports__